import React from 'react';
import LoadInvoice from './LoadInvoice';
import ShopInvoice from './ShopInvoice';
import TowingInvoice from './TowingInvoice';
import { styles } from './InvoiceCommon';
import { InvoiceType } from 'common/constants';


export default function Invoice({ invoice, customer, invoiceType, isPetroff, imageSrc, importedStyles, petroffImageSrc }) {    
    const commonStyles = {...styles, ...importedStyles};
    const props = { 
        invoice,
        customer,
        commonStyles,
        imageSrc,
        isPetroff,
        petroffImageSrc
    }

    if(invoiceType === InvoiceType.LOAD) {
        return  <LoadInvoice {...props}/>
    } else if(invoiceType === InvoiceType.SHOP) {
        return <ShopInvoice {...props}/>
    } else {
        return <TowingInvoice {...props}/>
    }
    
}
